<div class="card-header bg-success">
    <h3 *ngIf="routeType==2">Thank you for requesting a quotation from Insure My Alpaca. Please confirm:</h3>
    <h3 *ngIf="routeType!=2">Declaration Statement</h3>
</div>
<div class="card-body">
    <!-- Only show for equine proudct -->
    <div *ngIf="routeType==10">
        <h3 class="mb-2">Agreed Statements. Please read carefully.</h3>
    </div>
    <div *ngIf="routeType==11">
        <h3 class="mb-2">Please confirm that:</h3>
    </div>
    <div class="form-group bg-white p-3 text-green" *ngFor="let ques of agreedQuestions;" [innerHTML]="ques.text">
        {{ques.text}}
    </div>
    <!-- Never show a bare Agree/Disagree pair: if the statements didn't load, say so
         rather than letting the page look like the declaration is missing. -->
    <div class="alert alert-warning" *ngIf="agreedQuestions && agreedQuestions.length === 0">
        The declaration statements could not be loaded. Please refresh the page before continuing.
    </div>
    <p *ngIf="routeType==3">NOTE: PLEASE ENSURE THE PROPOSER IS AWARE THAT ANY INSURANCE CERTIFICATE ISSUED ON THIS
        APPLICATION WILL NOT COVER ANY PRE-EXISTING CONDITIONS OF THE ANIMAL (S) TO BE INSURED THAT ARE KNOWN TO THE
        PROPOSER.</p>
    <div class="form-group">
        <button (click)="agreedBtnAction()" class="btn btn-success btn-sm">Agree</button>
        <button (click)="disagreeBtnAction()" class="btn btn-danger btn-sm ml-2">Disagree</button>
    </div>
</div>